import styled from 'styled-components'

const Wrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  // cursor: pointer;
`

const ImgWrapper = styled.div`
  width: 100%;
  height: 86dvh;
  overflow: hidden;
  img {
    width: 100%;
    // height: auto;
    height: 100%;
    // max-height: 86dvh;
    display: block;
    object-fit: contain;
    pointer-events: none;
  }
`

const Slide = ({ src }) => {
  return (
    <Wrapper>
      <ImgWrapper>
        <img src={src} />
      </ImgWrapper>
    </Wrapper>
  )
}

export default Slide
